import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useState } from 'react';
import { StrictDateInput } from 'console/shared/components/fields';
import { ControlWithoutValidation } from 'console/shared/components/fields/control/without-validation';
import branding from 'shared/app/model/branding';
import { useBooleanState } from 'shared/hooks/state/boolean';
const default_installation_state = {
    device_installation_date: null,
    mileage: null,
    moto_hours: null,
    vehicle_in_operation_date: null,
};
export const InstallationDate = memo(function InstallationDate(props) {
    const { installation_state, save_device_settings } = props;
    const [installationState, setInstallationState] = useState(installation_state ?? default_installation_state);
    const [changed, , setChanged] = useBooleanState(false);
    const onChangeInstallationDate = useCallback((value) => {
        setChanged();
        setInstallationState((state) => ({
            ...state,
            device_installation_date: value,
        }));
    }, []);
    const onChangeDeviceInstallationDate = useCallback((value) => {
        setChanged();
        setInstallationState((state) => ({
            ...state,
            vehicle_in_operation_date: value,
        }));
    }, []);
    useEffect(() => {
        if (changed) {
            save_device_settings({
                installation_state: installationState,
            });
        }
    }, [installationState]);
    return (_jsxs(_Fragment, { children: [_jsx(ControlWithoutValidation, { label: "\u0414\u0430\u0442\u0430 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0438 \u043A\u043E\u0442\u043B\u0430", value: installationState.device_installation_date ?? 0, onChange: onChangeInstallationDate, field: StrictDateInput, help_id: "boiler_installation_date" }), _jsx(ControlWithoutValidation, { label: `Дата установки ${branding.name}`, value: installationState.vehicle_in_operation_date ?? 0, onChange: onChangeDeviceInstallationDate, field: StrictDateInput, help_id: "device_installation_date" })] }));
});
